import axios from "axios";
import { toast } from "react-toastify";
import Router from "next/router";

export async function bloquerMembre(pseudo, token) {
  const apiUrl =
    process.env.NEXT_PUBLIC_API_URL + "/api/membres/modifierbanliste";

  var bodyFormData = new FormData();
  bodyFormData.append("token", token);
  bodyFormData.append("pseudo", pseudo);

  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      // "User-Agent": "Choualbox Next",
    },
  };

  await axios.post(apiUrl, bodyFormData, options).then((response) => {
    if (response.data.status == 200) {
      toast(response.data.message, { type: "success" });
      Router.push("/");
    } else {
      toast(response.data.message, { type: "error" });
      Router.push("/");
    }
  });
}
